import { faker } from '@faker-js/faker';
export const useMockData = () => {
    const generateTopNavItems = (count = 25) => {
        const items = [];
        for (let i = 0; i < count; i += 1) {
            items.push(faker.location.city());
        }
        return items;
    };
    const getRandomNumber = (min, max) => {
        const _min = Math.ceil(min);
        const _max = Math.floor(max);
        return Math.floor(Math.random() * (_max - _min + 1)) + _min;
    };
    const generateChildNavItems = (count = 10) => {
        const items = [];
        for (let i = 0; i < count; i += 1) {
            items.push(faker.commerce.product());
        }
        return items;
    };
    const buildNav = (mainCount = 10) => {
        const items = [];
        const mainItems = generateTopNavItems(mainCount);
        mainItems.forEach(item => {
            items.push({
                label: item,
                children: generateChildNavItems(getRandomNumber(3, 25)),
            });
        });
        return items;
    };
    const buildUserAccountItems = (count = 5) => {
        const items = [];
        for (let i = 0; i < count; i += 1) {
            items.push({ label: faker.color.human() });
        }
        return items;
    };
    const buildSupportMenuItems = () => [
        { label: 'Knowledge base' },
        { label: 'Help for current page' },
        { label: 'New user request form' },
    ];
    return {
        generateTopNavItems,
        getRandomNumber,
        generateChildNavItems,
        buildNav,
        buildUserAccountItems,
        buildSupportMenuItems,
    };
};
